<template>
  <FlotoDeleteBtn
    :class="{ invisible: disabled }"
    :message="
      __t(
        asset.swComplianceAlert
          ? 'confirm_turoff_installation_notification'
          : 'confirm_turnon_installation_notification'
      )
    "
    @confirm="handleUpdate"
  >
    <template v-slot:trigger>
      <a
        href="javascript:;"
        :class="{
          'text-neutral': asset.swComplianceAlert,
          'text-secondary-red': !asset.swComplianceAlert,
          'mx-2': true,
        }"
        @click="$emit('trigger')"
      >
        <MIcon v-if="asset.swComplianceAlert" name="bell" size="lg" />
        <MIcon v-else name="bell-slash" size="lg" />
        <!-- <MTooltip>
          <template v-slot:trigger>
            <MIcon v-if="!asset.swComplianceAlert" name="bell" />
            <MIcon v-else name="bell-slash" />
          </template>
          {{
            __t(
              asset.swComplianceAlert
                ? 'turnoff_compliance_notification'
                : 'turnon_compliance_notification'
            )
          }}
        </MTooltip> -->
      </a>
    </template>
  </FlotoDeleteBtn>
</template>

<script>
export default {
  name: 'ComplinceNotificationBtn',
  props: {
    disabled: { type: Boolean, default: false },
    asset: { type: Object, required: true },
  },
  methods: {
    handleUpdate() {
      this.$emit('update', { swComplianceAlert: !this.asset.swComplianceAlert })
    },
  },
}
</script>
